/** Au moins un produit lié à la campagne (fiche produit dans les emails). */
export function campaignHasProducts(campaign) {
  const list = campaign?.products;
  return Array.isArray(list) && list.length > 0;
}

/** Communauté HubUP liée — variables / notifs email disponibles. */
export function campaignHubupConfigured(campaign) {
  return Boolean(String(campaign?.hubupGroupId || '').trim());
}
